import BoldSmallText from '@/components/BoldSmallText';
import BoldText from '@/components/BoldText';
import InformationBanner from '@/components/InformationBanner';
import RegularText from '@/components/RegularText';
import { handleSendMessageCrisp } from '@/helpers';
import { handleVisibleBanner, isOpenOrderNotesBannerSelector } from '@/redux/slice/banner.slice';
import { generalSettingSelector, handleSaveSettings } from '@/redux/slice/setting.slice';
import { BlockStack, Box, Card, Checkbox, Link } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

export const OrderNote = () => {
  const { t } = useTranslation('general_settings');
  const generalSettings = useSelector(generalSettingSelector);
  const dispatch = useDispatch();
  const isOpenOrderNotesBanner = useSelector(isOpenOrderNotesBannerSelector);

  return (
    <Card padding={'300'}>
      <BlockStack gap={'300'}>
        <Box>
          <BoldText>{t('sections.orderManagement.orderNote.title')}</BoldText>
          <RegularText tone="subdued">{t('sections.orderManagement.orderNote.helpText')}</RegularText>
        </Box>
        <InformationBanner
          isVisible={isOpenOrderNotesBanner}
          onDismiss={() =>
            dispatch(
              handleVisibleBanner({
                key: 'isOpenOrderNotesBanner',
                value: false,
              }),
            )
          }
        >
          <RegularText>
            Selected date and time are added to <BoldText as="span">Shopify order notes</BoldText> and you can print packing slips
            with included schedule.
          </RegularText>
        </InformationBanner>
        <Card padding={'300'}>
          <Checkbox
            label={t('sections.orderManagement.orderNote.addPackingSlipLabel')}
            helpText={t('sections.orderManagement.orderNote.addPackingSlipHelpText')}
            checked={generalSettings.dateTimeOnPackingSlip}
            onChange={() => dispatch(handleSaveSettings({ dateTimeOnPackingSlip: !generalSettings.dateTimeOnPackingSlip }))}
          />
        </Card>
        <Box color="text-emphasis">
          📦 If you dont know how it looks like. Please{' '}
          <Link onClick={() => handleSendMessageCrisp(t('sections.orderManagement.orderNote.message'))}>contact us</Link> for{' '}
          <BoldSmallText as="span">a demo.</BoldSmallText>
        </Box>
      </BlockStack>
    </Card>
  );
};
